const initialState = {
  organizers: [],
  lastVisible: null,
  hasMore: true,
};

const organizerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ORGANIZERS_SUCCESS":
      return {
        ...state,
        organizers: action.payload.isLoadingMore
          ? [...state.organizers, ...action.payload.data]
          : action.payload.data,
        lastVisible: action.payload.lastVisible,
        hasMore: action.payload.hasMore,
      };
    case "UPDATE_ORGANIZER_STATUS_SUCCESS":
      return {
        ...state,
        organizers: state.organizers.filter(
          (organizer) => organizer.id !== action.payload.id
        ),
      };
    default:
      return state;
  }
};

export default organizerReducer;
